import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { DISCONTINUED, REPLACEMENT } from '../../../../../consts';

import styles from './index.scss';

const ProductLabel = ({ type, firstElement, secondElement }) => {
    const ProductLabelClass = classNames({
        [styles.productLabel]: true,
        [styles.discontinued]: type === DISCONTINUED,
        [styles.replacement]: type === REPLACEMENT,
    });

    return (
        <span className={ProductLabelClass}>
            {firstElement && firstElement()}
            {secondElement && secondElement()}
        </span>
    );
};

ProductLabel.propTypes = {
    type: PropTypes.string,
    firstElement: PropTypes.func,
    secondElement: PropTypes.func,
};

export default ProductLabel;
